import React, { useCallback, useEffect, useState } from "react";
import classNames from "classnames";
import useGlobalInitData from "../../store/useGlobalInitData";
import { useHistory } from "react-router-dom";
import MessageBox from "../../../../components/message-box";
import request from "../../../../network/request";
import { formatTimestamp } from "../../../../utils/common";
import { ReservingItemTypes } from "../../interfaces/home";
import useGetCh from "../../../../hooks/useGetCh";
import { RESERVE_ORDER_STATUS, TAB_ID_SET } from "../../config/constants";
import CancelOrderModal from "../CancelOrderModal";
import CommonLoading from "../../../../components/CommonLoading";
import useBasicFormData from "../../store/useBasicFormData";
import { sendReport } from "../../../../utils/reporter";
import "./index.scss";

export interface ReservingCardProps {
  showHasReserveTip?: boolean;
}

export default function ReservingCard(props: ReservingCardProps) {
  const { showHasReserveTip = true } = props;
  const history = useHistory();
  const ch = useGetCh();
  const { globalInitData } = useGlobalInitData();
  const { setStoreTimeTabIndex } = useBasicFormData();
  const [showCancelModal, setShowCancelModal] = useState(false);
  const [curSelectReserveOrder, setCurSelectedReserveOrder] =
    useState<ReservingItemTypes | null>(null);

  useEffect(() => {
    setStoreTimeTabIndex(TAB_ID_SET.DATE_TAB);
  }, [setStoreTimeTabIndex]);

  const reservingCardList =
    globalInitData.reserveGoingRecordDto.reserveList || [];

  const onCancelReservationHandler = async (orderId) => {
    console.info(
      "取消预约地址",
      "module/maintenance/reserve/cancel",
      // orderDetail?.serviceOrderUuid
      orderId
    );
    setShowCancelModal(false);
    CommonLoading.show();
    sendReport({
      mcode: "取消预约点击",
      point: "P11183`B021",
    });
    try {
      const res: any = await request(
        "module/maintenance/reserve/cancel",
        {
          reserveUuid: orderId,
        },
        "POST",
        { pureReturn: true }
      );
      if (res?.code === 200) {
        MessageBox.toast("取消成功");
        CommonLoading.hide();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
      } else throw new Error(res?.msg);
    } catch (err) {
      const error = err as any;
      console.error("取消预约失败:", error?.message);
      MessageBox.toast(error?.message || "取消失败");
      window.location.reload(); // 失败也刷新页面
      CommonLoading.hide();
    }
  };

  const showCancelOrderModal = (reserveItem) => {
    setCurSelectedReserveOrder(reserveItem);
    setShowCancelModal(true);
    // onCancelReservationHandler(reserveItem.id);
  };

  const hideCancelOrderModal = () => {
    setShowCancelModal(false);
  };

  const onCancelModalConfirm = () => {
    console.log(
      "curSelectReserveOrderrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrrr",
      curSelectReserveOrder
    );
    onCancelReservationHandler(curSelectReserveOrder?.uuid);
  };

  const onModifyOrderHandler = (reserveItem) => {
    const { code, id } = reserveItem;
    console.log("jumppppppping.....", reserveItem);
    history.push(`/reservation/edit/${code}?reserveId=${id}&ch=${ch}`);

    sendReport({
      mcode: "修改预约点击",
      point: "P11183`B022",
    });
  };

  const onRouteToDetailHandler = useCallback(
    (detail) => {
      if (detail) {
        history.push(
          `/serviceOrders/orderDetail/reserveDetailV2?reserveOrderCode=${detail.code}&ch=${ch}`
        );

        sendReport({
          mcode: "预约成功查看详情点击",
          point: "P11183`B020",
        });
      }
    },
    [ch, history]
  );

  if (!reservingCardList?.length) {
    return null;
  }

  return (
    <div className="reserving-card-container">
      {reservingCardList.map((reserveItem) => {
        return (
          <div key={reserveItem.id} className="reserving-card-wrapper">
            <div className="header-field">
              <div className="left-side">
                {reserveItem.orderTypeText && (
                  <span className="title">{reserveItem.orderTypeText}</span>
                )}
                <span
                  className={classNames("reserve-state", {
                    "gray-label":
                      reserveItem.status ===
                      RESERVE_ORDER_STATUS.RESERVE_CANCEL,
                  })}
                >
                  {reserveItem.statusName}
                </span>
              </div>
              <div
                className="right-side"
                onClick={() => onRouteToDetailHandler(reserveItem)}
              >
                <span>详情</span>
                <i className="arrow-right" />
              </div>
            </div>
            <div className="body-field">
              <div className="form-info-item">
                <div className="label">服务门店</div>
                <div className="content">{reserveItem.shopName}</div>
              </div>
              {!!reserveItem.isDrivingOrder ? (
                <React.Fragment>
                  <div className="form-info-item">
                    <div className="label">取车时间</div>
                    <div className="content">
                      {formatTimestamp(reserveItem.bookingTime)}
                      {/* {reserveItem.bookingTime} */}
                    </div>
                  </div>
                  <div className="form-info-item">
                    <div className="label">取车地点</div>
                    <div className="content">{reserveItem.pickupAddress}</div>
                  </div>
                </React.Fragment>
              ) : (
                <div className="form-info-item">
                  <div className="label">预约时间</div>
                  <div className="content">
                    {formatTimestamp(reserveItem.preComeDate)}
                    {/* {reserveItem.preComeDate} */}
                  </div>
                </div>
              )}
            </div>
            <div className="actions-field">
              {reserveItem.allowCancel && (
                <div
                  className="action-btn plain cancel-reservation-btn"
                  onClick={() => {
                    showCancelOrderModal(reserveItem);
                  }}
                >
                  取消预约
                </div>
              )}
              {reserveItem.allowCancel && (
                <div
                  className="action-btn modify-reservation-btn"
                  onClick={() => onModifyOrderHandler(reserveItem)}
                >
                  修改预约
                </div>
              )}
            </div>
          </div>
        );
      })}
      {showHasReserveTip ? (
        <div className="notice-wrapper">
          <i className="info-icon" />
          <span className="tips-text">已有进行中预约单</span>
        </div>
      ) : null}
      <CancelOrderModal
        showModal={showCancelModal}
        onConfirm={onCancelModalConfirm}
        onCancel={hideCancelOrderModal}
      />
    </div>
  );
}
